import { createSlice } from "@reduxjs/toolkit";

const popupMessageSlice = createSlice({
  name: "popupMessage",
  initialState: {
    message: "",
    delay: 5000
  },
  reducers: {
    setPopupMessage(state, action) {
      // RTK/Immer: ili mutiraj polja, ili return novi state
      state.message = action.payload?.message ?? "";
      state.delay = action.payload?.delay ?? 5000;
    },
    clearPopupMessage(state) {
      state.message = "";
      state.delay = 5000;
    }
  }
});

export const { setPopupMessage, clearPopupMessage } = popupMessageSlice.actions;
export default popupMessageSlice.reducer;
